/**
 * URLs API service - re-reads a URL's extras and edits its discussion posts
 * (moderator only).
 */
export class UrlsApi {
  constructor(apiClient) {
    this.client = apiClient;
  }

  /**
   * Re-read a URL from its sources.
   * Returns `{ urlId, extra }`.
   */
  refreshUrl(urlId, { ai = false } = {}) {
    return this.client.post(`/urls/${urlId}/refresh`, { ai });
  }

  /**
   * Record a discussion post under a URL; its `link` picks the source.
   * Returns `{ urlId, source, id, post, failed }`; `failed` names the post when
   * its source couldn't be read.
   */
  addPost(urlId, post) {
    return this.client.post(`/urls/${urlId}/posts`, post);
  }

  /**
   * Update a discussion post under a URL.
   * Returns `{ urlId, source, id, post }`; `id` is the new one when `link` named
   * another post.
   */
  updatePost(urlId, source, postId, patch) {
    return this.client.patch(`/urls/${urlId}/posts/${source}/${postId}`, patch);
  }

  /**
   * Remove a discussion post under a URL.
   * Returns `{ urlId, source, id }`.
   */
  removePost(urlId, source, postId) {
    return this.client.delete(`/urls/${urlId}/posts/${source}/${postId}`);
  }

  /**
   * Re-read a source's posts on a URL — all of them, or only `postId`.
   * Returns `{ urlId, source, posts, failed }`: the posts read again, by id, and
   * the ones that couldn't be.
   */
  refreshPosts(urlId, source, postId) {
    const path = `/urls/${urlId}/posts/${source}`;
    return this.client.post(`${postId ? `${path}/${postId}` : path}/refresh`);
  }
}

export default UrlsApi;
